import React from 'react';
import { Modal, StyleSheet } from 'react-native';

import { IconClose, Pressable, Text, XStack, YStack } from '@fhs/ui';
import { useBoxRef } from '@fhs/utils';

import { tokens } from '../../tokens';

import { ActionSheetProps } from './types';

export const DesktopOptionSelectModal = ({
  headerTitle = '',
  onClose,
  isVisible,
  children,
}: ActionSheetProps) => {
  const handleRequestCloseRef = useBoxRef(() => {
    onClose();
  });

  return (
    <Modal
      visible={isVisible}
      transparent
      animationType="fade"
      onRequestClose={handleRequestCloseRef.current}
    >
      <YStack style={styles.container}>
        <Pressable
          aria-label="Close dropdown"
          accessible={false}
          focusable={false}
          onPress={handleRequestCloseRef.current}
          style={styles.overlay}
        />
        <YStack style={styles.modalWrapper}>
          {!!headerTitle && (
            <XStack style={styles.header}>
              <Text style={styles.headerTitle} weight="semibold">
                {headerTitle}
              </Text>
              <Pressable onPress={onClose}>
                <IconClose size={32} />
              </Pressable>
            </XStack>
          )}
          <YStack style={styles.content}>{children}</YStack>
        </YStack>
      </YStack>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  overlay: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    backgroundColor: tokens.colors.$blackOpacity75,
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 24,
    lineHeight: 33.6,
  },
  modalWrapper: {
    display: 'flex',
    padding: 28,
    width: 520,
    minHeight: 400,
    borderRadius: 12,
    backgroundColor: tokens.colors.$white,
    gap: 28,
  },
  content: {
    flex: 1,
  },
});
